export class Breed {
  name: string;
  _id: string;
  type: string;
}
